/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';

// eslint-disable-next-line @atlassian/react-entrypoint/no-imports-in-entrypoint-file
import { getProjectKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

/* eslint-disable eslint-comments/no-restricted-disable */

import { fg } from '@atlassian/jira-feature-gating';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { NavigationSettingAri } from '@atlassian/ari/navigation/setting';
import type { SubspacesQueryEntrypointProps } from './SubspacesQuery.entrypoint.types.tsx';

import parameters from './__generated__/SubspacesQuery$parameters';
import type { SubspacesQuery as SubspacesQueryType } from './__generated__/SubspacesQuery.graphql.ts';

type Queries = {
	projects: SubspacesQueryType;
};

type SubspacesQueryProps = {
	entityAri: string;
	ownerAri: string;
};

type SubspaceEntryPointComponent = EntryPointComponent<
	Queries,
	{},
	SubspacesQueryEntrypointProps,
	SubspacesQueryProps
>;

export const subspaceEntryPoint: EntryPoint<SubspaceEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		// TODO: register this entrypoint in the routes file issueNavigatorPageEntryPointWithNested
		// https://jplat.atlassian.net/browse/ANIP-912
		root: JSResourceForUserVisible<SubspaceEntryPointComponent>(
			/* webpackChunkName: "async-nav4-subspace-entrypoint" */ './SubspacesQuery.tsx',
			{
				includeInShellOnlySsrBundle: true,
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: (params: EntryPointRouteParams) => {
			const cloudId = params.tenantContext?.cloudId ?? '';
			let projectKey = '';
			if (params.context?.match.params?.projectKey) {
				projectKey = params.context.match.params.projectKey;
			} else if (params.context?.match.params?.issueKey && fg('move-issue-view-to-entrypoint')) {
				projectKey = getProjectKey(params.context.match, params.context.query);
			}

			const activationId = params.tenantContext?.activationId ?? '';

			const entityAri = NavigationSettingAri.create({
				activationId,
				firstPartyApp: 'jira',
				siteId: cloudId,
				settingId: `project-${projectKey.toLowerCase()}-subcontainer`,
			}).toString();
			const ownerAri = IdentityUserAri.create({
				userId: params.tenantContext.atlassianAccountId || 'UNKNOWN',
			}).toString();

			return {
				queries: {
					projects: {
						parameters,
						variables: {
							cloudId,
							projectKey,
							entityAri,
							ownerAri,
							noOfBoardsToFetch: 0,
							skipOrderQuery: false,
						},
					},
				},
				extraProps: {
					entityAri,
					ownerAri,
				},
			};
		},
	});
